/* ══════════════════════════════════════════════════════════════════
   CigarVIU · 商品格換頁不重載 v1 · 2026-09-25
   ------------------------------------------------------------------
   問題:Dawn 的分頁是一般連結。新世界頁的商品格在手機上位於第 5,700px,
   每換一頁整頁重載(915 KB)、回到頁首,客人要再滑 5,700px 才看得到商品。

   做法:攔截 #ProductGridContainer 裡的分頁連結,用 Section Rendering API
   只抓商品格那一個 section(實測 304 KB、370 ms),換掉格子內容,
   網址改成 ?page=N(pushState),畫面捲回商品格頂端。

   不會靜默失敗:
   · 8 秒拿不到、非 2xx、回應裡找不到商品格 → 直接走一般連結
     (連結本身帶 #ProductGridContainer,重載後也會停在商品格)
   · 按 Ctrl/Cmd/Shift/中鍵 → 不攔截,照瀏覽器預設開新分頁
   上一頁/下一頁:有篩選器時交給 Dawn facets.js 的 popstate 處理
   (它本來就會依網址參數重畫商品格);沒有篩選器的頁面直接重載。
   ══════════════════════════════════════════════════════════════════ */
(() => {
  const CONTAINER_ID = 'ProductGridContainer';
  const TIMEOUT_MS = 8000;
  let busy = false;

  const container = () => document.getElementById(CONTAINER_ID);

  const headerOffset = () => {
    const header = document.querySelector('sticky-header, .section-header');
    const h = header ? header.getBoundingClientRect().height : 0;
    return Math.max(0, h) + 12;
  };

  const scrollToGrid = (smooth) => {
    const el = container();
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: smooth && !reduce ? 'smooth' : 'auto' });
  };

  const load = (link) => {
    const el = container();
    const grid = document.getElementById('product-grid');
    const sectionId = grid && grid.dataset.id;
    if (!el || !sectionId) return false;

    const url = new URL(link.href, window.location.href);
    url.hash = '';
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', sectionId);

    busy = true;
    const collection = el.querySelector('.collection');
    if (collection) collection.classList.add('loading');
    scrollToGrid(true);

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);

    fetch(fetchUrl.toString(), { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((html) => {
        const next = new DOMParser().parseFromString(html, 'text/html').getElementById(CONTAINER_ID);
        if (!next) throw new Error('ProductGridContainer not found');
        el.innerHTML = next.innerHTML;

        // Dawn 的捲動進場動畫:新塞進來的卡片要重新註冊,否則停在透明。
        // 參數必須是元素(Dawn facets.js 傳 html.innerHTML 是它自己的 bug,實測會丟例外)。
        // 動畫不是必要功能,失敗也不能把已經換好的商品格打回整頁重載。
        try {
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(el);
        } catch (e) {
          el.querySelectorAll('.scroll-trigger').forEach((n) => n.classList.add('scroll-trigger--cancel'));
        }

        const search = url.searchParams.toString();
        history.pushState({ searchParams: search }, '', url.pathname + (search ? `?${search}` : ''));
        if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = search;

        scrollToGrid(false);
        const first = el.querySelector('#product-grid .card__heading a');
        if (first) first.focus({ preventScroll: true });
      })
      .catch(() => {
        window.location.href = link.href;
      })
      .finally(() => {
        clearTimeout(timer);
        busy = false;
        const c = container() && container().querySelector('.collection');
        if (c) c.classList.remove('loading');
      });

    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`#${CONTAINER_ID} .pagination a[href]`);
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    if (!load(link)) window.location.href = link.href;
  });

  window.addEventListener('popstate', () => {
    if (typeof FacetFiltersForm === 'undefined') window.location.reload();
  });
})();
